import { render, staticRenderFns } from "./ClassifyAdm.vue?vue&type=template&id=0fe36c6e&scoped=true&"
import script from "./ClassifyAdm.vue?vue&type=script&lang=js&"
export * from "./ClassifyAdm.vue?vue&type=script&lang=js&"
import style0 from "./ClassifyAdm.vue?vue&type=style&index=0&id=0fe36c6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe36c6e",
  null
  
)

export default component.exports